import { FeatureFlagsActionTypes } from '../actions';

export interface FeatureFlagsState {
	appFeaturePopup: any;
  [key: string] : any
}

export const featureFlagsInitialState: FeatureFlagsState = {
	appFeaturePopup: null
};

export function reducer(state = featureFlagsInitialState, action: any): FeatureFlagsState {
  if (action.type === FeatureFlagsActionTypes.SET_FEATURE_FLAGS) {
    return Object.assign({}, action.payload);
  }
  return state;
}
